import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as BaseExclamationIcon } from 'assets/images/exclamation-circle-filled.svg';

export const Container = styled.section`
  text-align: center;
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 20px;
  color: ${ColorPalette.HEX.CharlestonGreen};
  font-weight: bold;
  margin-bottom: 24px;
`;

export const Detail = styled.span`
  font-size: 14px;
  color: ${ColorPalette.HEX.DimGray};
  margin-bottom: 16px;
`;

export const Item = styled.span`
  font-size: 14px;
  color: ${ColorPalette.HEX.CharlestonGreen};
  font-weight: 600;
`;

export const ExclamationIcon = styled(BaseExclamationIcon)`
  color: ${ColorPalette.HEX.RedRYB};
  margin-right: 8px;
`;

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-top: 32px;
`;

export const CancelButton = styled.button`
  border-radius: 12px;
  border: solid 2px ${({ theme }) => theme.confirmationModal.buttonColor};
  background: ${({ theme }) => theme.confirmationModal.buttonBackground};
  color: ${({ theme }) => theme.confirmationModal.buttonColor};
  width: 100%;
  height: 50px;
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.53;
  letter-spacing: -0.1px;
  text-align: center;
  cursor: pointer;
`;
